/**
 * editor2/shared/FieldDisplay.tsx
 * クリックで編集ダイアログを開くフィールド表示コンポーネント
 * ReservationEditorPanel の DetailItem + onClick パターンを抽出
 */
import React from 'react';
import { useFieldMark, markBoxStyle, FieldMarkChip } from '../conflict/fieldState';

interface FieldDisplayProps {
  label: string;
  value: any;
  onClick?: () => void;
  noBorder?: boolean;
  color?: string;
  suffix?: string;
  displayValue?: string;
  /** この表示が扱う予約フィールド名（変更/他端末更新/競合の色分けと、ヘッダーからのスクロール先に使う） */
  fields?: readonly string[];
}

export default function FieldDisplay({
  label,
  value,
  onClick,
  noBorder = false,
  color,
  suffix,
  displayValue,
  fields,
}: FieldDisplayProps) {
  const shown = displayValue ?? (value != null && value !== '' ? String(value) : '-');
  const isClickable = !!onClick;
  const mark = useFieldMark(fields);

  return (
    <div className={`gc-field${mark ? ` gc-field--${mark}` : ''}`} data-field={fields?.join(' ')}>
      <label
        className="gc-label"
        style={{ fontSize: '0.85rem', color: '#475569', fontWeight: 600 }}
      >
        {label}
        <FieldMarkChip mark={mark} />
      </label>
      <div
        className="gc-input"
        onClick={onClick}
        role={isClickable ? 'button' : undefined}
        tabIndex={isClickable ? 0 : undefined}
        onKeyDown={
          isClickable
            ? (e: React.KeyboardEvent) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  onClick?.();
                }
              }
            : undefined
        }
        style={{
          background: isClickable ? '#fff' : '#f8fafc',
          border: noBorder ? 'none' : '1px solid #cbd5e1',
          borderRadius: '4px',
          padding: '8px 12px',
          minHeight: '38px',
          display: 'flex',
          alignItems: 'center',
          color: color || '#0f172a',
          fontWeight: 500,
          cursor: isClickable ? 'pointer' : 'default',
          transition: 'background 0.15s',
          ...markBoxStyle(mark),
        }}
      >
        <span style={{ flex: 1 }}>{shown}</span>
        {suffix && (
          <span style={{ marginLeft: 4, color: '#94a3b8', fontSize: '0.85rem' }}>
            {suffix}
          </span>
        )}
      </div>
    </div>
  );
}
